import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column vh-100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center text-black position-fixed w-100 top-0",
  style: {"height":"50px","z-index":"1030"}
}
const _hoisted_3 = {
  class: "d-flex",
  style: {"width":"250px"}
}
const _hoisted_4 = {
  class: "btn",
  style: {"color":"white","border-radius":"0px","width":"50px","background-color":"#0094de","padding":"0"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "dropdown",
  style: {"margin-right":"20px"}
}
const _hoisted_7 = {
  class: "btn dropdown-toggle p-0",
  type: "button",
  id: "userDropdown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  style: {"color":"black"}
}
const _hoisted_8 = {
  class: "dropdown-menu dropdown-menu-end dropdown-menu-with-arrow",
  style: {"border":"none","box-shadow":"10px 10px 10px 10px gainsboro","top":"10px"},
  "aria-labelledby": "userDropdown"
}
const _hoisted_9 = {
  class: "d-flex flex-grow-1",
  style: {"margin-top":"50px"}
}
const _hoisted_10 = {
  class: "flex-grow-1 d-flex flex-column",
  style: {"background-color":"#0094de","width":"250px"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 0,
  class: "ms-2"
}
const _hoisted_14 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_15 = {
  key: 1,
  class: "text-center pt-2"
}
const _hoisted_16 = {
  key: 2,
  class: "chat-popup"
}

import { ref, computed, provide, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { Role, useAuthStore } from "./stores/auth"
import MessagingPopup from "./components/MessagePopup/MessagingPopup.vue"

// Icons
import menuIcon from "@/assets/icons/menu.png"

// Import both white and green icons
// Dashboard icons
import dashboardWhite from "@/assets/icons/HomeWhite.png"
import dashboardGreen from "@/assets/icons/DashboardBlue.png"

// Store icons
import storesWhite from "@/assets/icons/StoreWhite.png"
import storesGreen from "@/assets/icons/StoresBlue.png"

// User icons
import userWhite from "@/assets/icons/UserWhite.png"
import userGreen from "@/assets/icons/UsersBlue.png"

// Driver icons
import driversWhite from "@/assets/icons/DriverWhite.png"
import driversGreen from "@/assets/icons/DriversBlue.png"

// Delivery icons
import deliveriesWhite from "@/assets/icons/DeliveryWhite.png"
import deliveriesGreen from "@/assets/icons/DeliveriesBlue.png"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

const showSidebar = ref(true)
const toggleSidebar = () => {
  showSidebar.value = !showSidebar.value
}

// Updated to account for fixed sidebar
const mainContentStyle = computed(() => {
  const shouldShowSidebar = !isLoginPage.value && !isForgotPassword.value && showSidebar.value
  return {
    marginLeft: shouldShowSidebar ? "250px" : "0px",
    marginRight: "0px",
    transition: "margin-left 0.3s ease-in-out"
  }
})

const currentUserRole = computed(() => auth.userInfo?.role ?? Role.None)
const user = computed(() => (auth.isAuthenticated() ? auth.userInfo?.name : undefined))
const isLoginPage = computed(() => route.name === "Login")
const isForgotPassword = computed(() => route.name === "ForgotPassword")
// Unified route list (Dashboard included)
const routes = computed(() => {
  const list = [{ to: "/", title: "Dashboard" }]
  if (currentUserRole.value === Role.Admin) {
    list.push({ to: "/stores", title: "Stores" })
  }
  if (currentUserRole.value !== Role.Driver) {
    list.push({ to: "/users", title: "Users" })
    list.push({ to: "/drivers", title: "Drivers" })
  }
  list.push({ to: "/deliveries", title: "Deliveries" })
  return list
})

const getIconForRoute = (routeTitle: string, isActive: boolean) => {
  switch (routeTitle) {
    case "Dashboard":
      return isActive ? dashboardGreen : dashboardWhite
    case "Stores":
      return isActive ? storesGreen : storesWhite
    case "Users":
      return isActive ? userGreen : userWhite
    case "Drivers":
      return isActive ? driversGreen : driversWhite
    case "Deliveries":
      return isActive ? deliveriesGreen : deliveriesWhite
    default:
      return isActive ? dashboardGreen : dashboardWhite
  }
}

function logout() {
  auth.logout()
}

provide("setQuery", setQuery)

async function setQuery(key: string, value?: string) {
  const query = route.query
  return router.replace({ query: { ...query, [key]: value } })
}

// Ensure dropdown initializes properly
onMounted(() => {
  const dropdownToggle = document.getElementById("userDropdown")
  if (dropdownToggle) {
    new bootstrap.Dropdown(dropdownToggle)
  }
})

const navBarTitleColor = computed(() => true) // Always enable the title styling
const navbarTitleStyle = computed(() => ({
  color: showSidebar.value ? "white" : "#0094DE", // White text when sidebar is open
  backgroundColor: showSidebar.value ? "#0094DE" : "white" // #0094DE background when sidebar is open
}))

// Computed property to determine if the MessagingPopup should be displayed
const shouldShowMessagingPopup = computed(() => {
  return currentUserRole.value === Role.Manager || currentUserRole.value === Role.Driver
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoginPage.value && !isForgotPassword.value)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", _hoisted_4, [
              _createElementVNode("img", {
                src: _unref(menuIcon),
                alt: "Menu",
                style: {"vertical-align":"middle"},
                onClick: toggleSidebar
              }, null, 8, _hoisted_5)
            ]),
            (navBarTitleColor.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle([navbarTitleStyle.value, {"text-align":"center"}]),
                  class: "fw-bold flex-fill navbar-Title"
                }, "Datascan Delivery", 4))
              : _createCommentVNode("", true)
          ]),
          (user.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, "Hi, " + _toDisplayString(user.value), 1),
                _createElementVNode("ul", _hoisted_8, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dropdown-arrow" }, null, -1)),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      style: {"color":"red"},
                      href: "#",
                      onClick: _withModifiers(logout, ["prevent"])
                    }, "Log Out")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (!isLoginPage.value && !isForgotPassword.value)
        ? (_openBlock(), _createElementBlock("aside", {
            key: 0,
            class: _normalizeClass(['sidebar bg-dark text-white p-0 d-flex flex-column position-fixed', { collapsed: !showSidebar.value }]),
            style: {"top":"50px","height":"calc(100vh - 50px)","z-index":"1020"}
          }, [
            _createElementVNode("div", _hoisted_10, [
              (user.value)
                ? (_openBlock(), _createElementBlock("ul", {
                    key: 0,
                    class: _normalizeClass(['nav flex-column mt-4', { 'text-center': !showSidebar.value }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.value, (route) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: route.to,
                        to: route.to,
                        custom: ""
                      }, {
                        default: _withCtx(({ isActive, navigate }) => [
                          _createElementVNode("li", {
                            class: "nav-item mb-3",
                            onClick: navigate
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["nav-link text-white d-flex align-items-center", { active: isActive, 'justify-content-center': !showSidebar.value }])
                            }, [
                              _createElementVNode("img", {
                                src: getIconForRoute(route.title, isActive),
                                alt: route.title,
                                class: "nav-icon"
                              }, null, 8, _hoisted_12),
                              (showSidebar.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(route.title), 1))
                                : _createCommentVNode("", true)
                            ], 2)
                          ], 8, _hoisted_11)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("main", {
        class: "d-flex flex-column p-3 overflow-auto position-relative w-100",
        style: _normalizeStyle(mainContentStyle.value)
      }, [
        _createVNode(_component_router_view, { class: "d-flex flex-column flex-fill" }),
        (!isLoginPage.value)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_14))
          : _createCommentVNode("", true),
        (!isLoginPage.value)
          ? (_openBlock(), _createElementBlock("footer", _hoisted_15, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("small", null, "© 2025 - Datascan Delivery Portal", -1)
            ]))]))
          : _createCommentVNode("", true),
        (shouldShowMessagingPopup.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(MessagingPopup)
            ]))
          : _createCommentVNode("", true)
      ], 4)
    ])
  ]))
}
}

})